/**
 * スマホ用メニューを生成（Vanilla JS） ver1.0.0
 * ES6
 *
 * □機能
 *
 * □使い方
 *
 */
export default (APP) => {
  const $drawer = document.getElementById('drawer-content')
  const targets = document.querySelectorAll('[data-drawer]')

  const sortedArray = createSortArray(targets)
  creatDrawer($drawer, sortedArray)

  /*
   * data-drawer の 数値 を判断し、
   * 小さい値ほど先頭になるように並び替える
   */
  function createSortArray (targets) {
    const sortArray = []
    let sortNumberBefore = 0
    const targetsLength = targets.length

    for (let i = 0; i < targetsLength; i++) {
      const $target = targets[i]
      const $clone = $target.cloneNode(true)
      const data = $clone.getAttribute('data-drawer')
      const dataArray = data.split(',')

      const sortNumber = dataArray[0]
      const addClassName = (dataArray[1]) ? dataArray[1] : ''

      $clone.className = ''
      $clone.removeAttribute('id')
      $clone.className = addClassName

      if (sortNumber <= sortNumberBefore) {
        sortArray.unshift($clone)
      } else {
        sortArray.push($clone)
      }

      $clone.removeAttribute('data-drawer')

      sortNumberBefore = sortNumber
    }

    return sortArray
  }

  /*
   * 配列の順序に従って、オブジェクトを$elementに追加する
   */
  function creatDrawer ($element, sortArray) {
    const length = sortArray.length

    for (let i = 0; i < length; i++) {
      $element.appendChild(sortArray[i])
    }
  }
}
